$ = require 'jquery'
ActionView = require 'views/action/action-view'
CommentActionView = require 'views/action/comment-action-view'
Dates = require 'lib/dates'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
moment = require 'moment'

module.exports = class ActionListView extends View

  initialize: ({ @renderOpts, @highlight }) ->
    @makeDebouncedMethods 'render'
    @listenTo @collection, 'add remove reset', @renderDebounced
    @actionViews = []
    @showDetails = true

  render: ->
    @collection._getRelatedBoards().then =>
      rerenderAll = @$el.html() == '' || (@showDetails != @_lastShowDetails) || @missingViews()
      @_lastShowDetails = @showDetails
      @rerender(rerenderAll, true)
      return
    .then =>
      @trigger 'render'
      return
    .done()

  missingViews: ->
    # We can lose a view when an action is deleted; if we don't reset anything
    # then we'll do dumb things like trying to insert an action before something
    # that isn't in the DOM anymore
    _.any @actionViews, (view) =>
      !$.contains(@el, view.el)

  rerender: (rerenderAll, removeExisting) ->
    [editTexts, cursorPos] = @saveEdits()

    allActions = @collection.models
    allActions = _.sortBy(allActions, (a) ->
      -Dates.parse(a.get('date'))
    )
    if !@showDetails
      allActions = _.filter allActions, (a) ->
        a.isCommentLike()

    actionList = removeCanceled(allActions).slice(0, @renderOpts.limit)
    # Rendering an action should happen:
    # 1. When all the actions need to be rerendered. This is handled
    #    separately for append efficiency
    # 2. When it is a new action added to the action list. All current actions
    #    shouldn't rerender
    # 3. When an action is replaced with another action. All current actions
    #    shouldn't rerender
    #
    # Rerendering should not happen:
    # 1. When a comment action is deleted, unless (in the case of the sidebar)
    #    a new action fills its place.

    if rerenderAll && removeExisting
      @removeActionViews()

    # Add an empty message for board member profiles.
    @$('.js-board-member-profile-no-activity').toggleClass('hide', actionList.length > 0)

    for action, index in actionList
      if rerenderAll || @actionNeedsRerender(action, index)
        view = @rerenderAction(action, index, actionList,
          { rerenderAll })
        @restoreEdits(editTexts, cursorPos, view)
    return

  setShowDetails: (value) ->
    @showDetails = value

  # Attempts to save in-progress comment edits
  saveEdits: ->
    editTexts = []
    cursorPos = 0
    @$('.editing textarea').each ->
      $textarea = $(@)
      editTexts.push($textarea.val())
      if $textarea.is(':focus')
        $textarea.parents('.editing').addClass('focused')
        cursorPos = Util.getCaretPosition($textarea)
      return

    if editTexts?
      editTexts.reverse()

    [editTexts, cursorPos]

  restoreEdits: (editTexts, cursorPos, view) ->
    if view.$el.hasClass('editing')
      view.$('textarea').val(editTexts.pop())
      textarea = Util.getElem(view.$('textarea'))
      if view.$el.hasClass('focused')
        Util.setCaretPosition(textarea, cursorPos)
      view.openEditView()

  _viewForAction: (action) ->
    if /^comment/.test(action.get('type'))
      @subview(CommentActionView, action, @renderOpts)
    else
      @subview(ActionView, action, @renderOpts)

  rerenderAction: (action, index, actionList, options) ->
    view = @_viewForAction(action)

    isHighlighted = @highlight && @highlight == action.id
    view.setHighlighted(isHighlighted)

    if options.rerenderAll
      @appendSubview(view)
      @actionViews.push(view)
    else
      @insertActionView(view, index)

      # If this is the last view being rendered, just replace the current view
      # at index with this one. Special case is when there's only one actionView
      # and it's being replaced because we can't check if the next action in
      # actionList matches the next actionView
      if @actionViews.length == 1 && actionList.length == 1
        @actionViews[index].remove()
        @actionViews.splice(index, 1, view)
      else if !@actionViews[index + 1]?
        @actionViews.splice(index, 1, view)
      else if actionList.length <= @actionViews.length
        # If there aren't more actions in actionList than currently rendered,
        # we need to remove some views
        # If the next action in actionList matches the next actionView,
        # then we should replace the current actionView with the rerendered
        # actionView
        if @actionViews[index + 1].model.id == _.first(actionList[index + 1])?.id
          @actionViews[index].remove()
          @actionViews.splice(index, 1, view)
        else
          # If the view isn't replacing the one already in that place,
          # then remove a view from the end instead.
          @actionViews.splice(index, 0, view)
          @actionViews[@actionViews.length - 1]?.remove()
          @actionViews = @actionViews.splice(0, @actionViews.length - 1)
      else
        @actionViews.splice(index, 0, view)

    view

  actionNeedsRerender: (action, index) ->
    # Sometimes when actionViews are created with client only codepaths, the id
    # of the actionView is undefined. Comparing an undefined id to an undefined
    # next actionView would remove the actionView, disconnecting its events. To
    # fix this, we check the cid attribute when there is no id.
    idKey = if action.id? then 'id' else 'cid'
    # If the next actionView corresponds to the current model, then the action
    # for the current actionView must have been removed
    if @actionViews[index + 1]?.model?[idKey] == action[idKey]
      @actionViews[index].remove()
      @actionViews.splice(index, 1)

    actionView = @actionViews[index]

    !actionView || action[idKey] != actionView.model[idKey]

  insertActionView: (view, position) ->
    if @actionViews[position]
      view.delegateEvents()
      view.render().$el.insertBefore(@actionViews[position].el)
    else
      @appendSubview(view)

  removeActionViews: ->
    @removeSubviews()
    @actionViews = []
    return

  delegateEvents: ->
    super
    for actionView in @actionViews
      actionView.delegateEvents()
    return

  undelegateEvents: ->
    super
    for actionView in @actionViews
      actionView.undelegateEvents()
    return

  remove: ->
    @removeActionViews()
    super

  setHighlight: (id) ->
    if id == @highlight
      return

    if @highlight && (oldAction = @collection.get(@highlight))?
      view = @_viewForAction(oldAction)
      view.setHighlighted(false)

    @highlight = id

    if @highlight && (action = @collection.get(@highlight))
      view = @_viewForAction(action)
      view.setHighlighted(true)
    return


same = (model) -> (cancel) -> (a, b) ->
  isSameModel = model of a && model of b && a[model].id == b[model].id
  if isSameModel
    cancel(a, b)
  else
    [false, false]

sameCard = same('card')
sameBoard = same('board')

dup = (a) -> [a, a]

doubleOr = ([a, b], [c, d]) -> [a || c, b || d]

has = (keypath, obj) ->
  if !obj?
    return false
  if keypath.length == 0
    return true
  [head, tail...] = keypath
  has(tail, obj[head])

have = (keypath, objs...) ->
  _.all objs, (obj) ->
    has(keypath, obj)

cancelingPairs = [
  a: 'removeMemberFromCard',
  b: 'addMemberToCard',
  cancel: sameCard (a, b) -> dup(a.idMember == b.idMember)
,
  a: 'deleteAttachmentFromCard'
  b: 'addAttachmentToCard'
  cancel: sameCard (a, b) -> dup(a.attachment.id == b.attachment.id)
,
  a: 'updateCheckItemStateOnCard'
  b: 'updateCheckItemStateOnCard'
  cancel: sameCard (a, b) -> dup(a.checkItem.id == b.checkItem.id)
,
  a: 'updateCard'
  b: 'updateCard'
  cancel: sameCard (a, b) -> dup(
    'listAfter' of a &&
    'listBefore' of b &&
    a.listAfter.id == b.listBefore.id
  )
,
  a: 'addChecklistToCard'
  b: 'removeChecklistFromCard'
  cancel: sameCard (a, b) -> dup(a.checklist.id == b.checklist.id)
,
  a: 'updateBoard'
  b: 'updateBoard'
  cancel: sameBoard (a, b) -> [
    have(['board', 'prefs', 'background'], a, b)
    false
  ]
]

shouldCancel = (a, b) ->
  cancelingPairs.reduce (val, pair) ->
    if a.type != pair.a || b.type != pair.b
      val
    else
      doubleOr val, pair.cancel(a, b)
  , [false, false]

removeCanceled = (actions) ->
  if actions.length == 1
    return actions

  canceled = {}
  for actionA, ixA in actions.slice(0, -1)
    dataA = actionA.toJSON()
    dataB = actions[ixA + 1].toJSON()
    _.extend dataA, dataA.data
    _.extend dataB, dataB.data

    if dataA.idMemberCreator == dataB.idMemberCreator &&
       moment(dataA.date).diff(dataB.date, 'minutes') < 5 &&
       !canceled[dataA.id] && !canceled[dataB.id]
      [cancelA, cancelB] = shouldCancel(dataA, dataB)
      if cancelA then canceled[dataA.id] = true
      if cancelB then canceled[dataB.id] = true

  _.reject actions, (action) -> canceled[action.id]



// WEBPACK FOOTER //
// ./app/scripts/views/action/action-list-view.coffee